import { useCallback } from 'react';
import { TableFilterStateDto } from '../../../components/table/DataTable';
import { paymentService } from '../../../services/Payment/paymentService';

export const useOrganizationFilters = () => {
  const onTableFiltered = useCallback((tableState: TableFilterStateDto<Map<string, any>>) => {
    const params: any = {
      page: tableState.page,
      size: tableState.pageSize,
      keywords: tableState.filtersMap?.get('keywords') || undefined,
      ein: tableState.filtersMap?.get('ein') || undefined,
    };

    if (tableState.sortBy) {
      params.sort = `${tableState.sortBy},${tableState.sortDirection || 'asc'}`;
    }

    return paymentService.fetchOrganizations(params).then(response => response.data);
  }, []);

  const filterInitState = new Map<string, any>();

  return { onTableFiltered, filterInitState };
};
